import { constants, mediaQueryStyles } from "@newsela/angelou";
const { mediaQuery } = mediaQueryStyles;

export const actionListContainerCss = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  [mediaQuery.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    flexFlow: "column",
    width: "100%",
  },
};

export const addIconCss = {
  height: "1.5rem",
  width: "1.5rem",
};

export const buttonActionCss = {
  height: "48px",
  "&:last-child": {
    marginLeft: "16px",
  },
  [mediaQuery.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    margin: "0 0 1rem 0",
    width: "100%",
    "&:last-child": {
      margin: "0",
    },
  },
};
